<div class="how-it-works-banner">
    <div class="shippn-homepage-container container">
        <div class="row">
            <div class="col-md-12">
                <h1 class="background-text"
                    style="text-align: center;font-weight: bold;margin-bottom: 100px;color: white;margin-top: 125px;">
                    How international package <br> forwarding with Shippn works?
                </h1>
            </div>
        </div>
    </div>
</div>



<section class="how-it-works-section">

    <div class="shippn-homepage-container container how-it-works-container">
        <div class="how-it-works-header">
            <div class="how-it-works-header-content">
                <p>
                    <span class="color-orange">Shippn</span> is a community of trusted members helping each other unlock
                    a world of opportunities to shop
                    from
                    anywhere in the world.
                </p>
            </div>
            <div class="how-it-works-header-image">
                <img src="../../assets/img/how-it-works/for-host/how-it-works-host-shop-anywhere.jpg"
                    alt="Shippn Shop Anywhere To Everywhere">
            </div>
        </div>
        <div class="how-it-works-header">
            <div class="how-it-works-header-image">
                <img src="../../assets/img/how-it-works/for-host/how-it-works-host-head-one.jpeg"
                    alt="Shippn Shop Anywhere To Everywhere">

            </div>
            <div class="how-it-works-header-content">
                <p>
                    At <span class="color-orange">Shippn</span> there are shoppers and hosts. Shoppers need help
                    shopping from abroad
                    to overcome issues with international delivery, hosts are individuals who can provide their address
                    for
                    shopping and help with international package forwarding.
                </p>

            </div>

        </div>
        <div class="how-it-works-header-action">
            <p class="head-paragraph">
                You can become a member to shop or register as
                a host at <span class="color-orange">Shippn</span> and instantly start shopping the world.
            </p>
            <button (click)="goBecomeAHost()" class="btn btn-orange">Become a Host</button>
        </div>
    </div>


</section>

<!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#f4f4f4" fill-opacity="1" d="M0,0L48,5.3C96,11,192,21,288,53.3C384,85,480,139,576,144C672,149,768,107,864,122.7C960,139,1056,213,1152,250.7C1248,288,1344,288,1392,288L1440,288L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path></svg> -->
<section class="how-it-works-section bg-white-grey pad-top-0">
    <div class="shippn-homepage-container container how-it-works-container">
        <div class="how-it-works-explanation-wrapper">
            <div class="how-it-works-explanation-item">
                <div class="how-it-works-explanation-item-image">
                    <img src="../../assets/img/how-it-works/for-host/how-it-works-host-sign-up-person.jpg"
                        alt="Shippn how it works for host image">
                    <!-- <img src="../../assets/img/how-it-works-for-hosts-icon.png" alt="Shippn how it works for host image"> -->
                </div>
                <div class="how-it-works-explanation-item-content">
                    <h4 class=" color-orange">
                        Sign up as a host
                    </h4>
                    <p>
                        Start by creating your profile page and complete verifications. You’ll fill out a description,
                        and
                        state the additional services you serve. Your profile helps shoppers get a sense of the services
                        you
                        offer.
                        You set the rules for when you are available.
                    </p>
                    <p>
                        We’re here to help. From getting you ready and
                        understanding your responsibilities, we’ve got tools and resources for you.
                    </p>
                    <button (click)="goBecomeAHost()" class="btn btn-orange">Become a Host</button>
                </div>
            </div>
            <div class="how-it-works-explanation-item direction-left">

                <div class="how-it-works-explanation-item-content">
                    <h4 class=" color-orange">
                        Shoppers find your listing and pay for your services
                    </h4>
                    <p>
                        You’ll get a message from us about shopper’s package and forwarding options selected by the
                        shopper.
                        You can also see the expected package’s details on your account dashboard.
                    </p>
                    <p>
                        Pay attention to your shopper’s notes. These are important to provide a great service.
                    </p>
                </div>
                <div class="how-it-works-explanation-item-image">
                    <img src="../../assets/img/how-it-works-search-host.png" alt="Shippn How it works hosts 2">
                </div>
            </div>
            <div class="how-it-works-explanation-item">
                <div class="how-it-works-explanation-item-image">
                    <img src="../../assets/img/how-it-works-packages.png" alt="Shippn How it works hosts 2">
                </div>
                <div class="how-it-works-explanation-item-content">
                    <h4 class="color-orange">

                        Host packages and ship when ready
                    </h4>
                    <p>
                        Hosting packages with <span class="color-orange">Shippn</span> is easy. Enter package details
                        with a few clicks and your shopper
                        will instantly get a notification indicating their package is ready to ship. How shoppers pay?
                    </p>
                </div>
            </div>

            <div class="how-it-works-explanation-item direction-left">

                <div class="how-it-works-explanation-item-content">
                    <h4 class="color-orange">

                        How shoppers pay?
                    </h4>
                    <p>
                        <span class="color-orange">Shippn</span> handles all of the payments you never have to deal with
                        money. Shoppers pay even before
                        you
                        receive their package.
                    </p>
                </div>
                <div class="how-it-works-explanation-item-image">
                    <img src="../../assets/img/how-it-works-for-hosts-icon-2.png" alt="Shippn How it works hosts 2">
                </div>
            </div>
            <div class="how-it-works-explanation-item">
                <div class="how-it-works-explanation-item-image">
                    <img src="../../assets/img/how-it-works-host-payment.png" alt="Shippn How it works hosts 2">
                </div>
                <div class="how-it-works-explanation-item-content">
                    <h4 class="color-orange">

                        How you get paid?
                    </h4>
                    <p>
                        You get paid with Paypal. Your payment is automatically sent the first monday
                        after the package is delivered. Easy
                    </p>
                    <p>
                        Listing your service on <span class="color-orange">Shippn</span> is free.
                    </p>
                    <img src="assets/img/svg-original-colors/payment-paypal.svg" alt="Paypal SVG Logo, Shippn">
                </div>
            </div>
        </div>

        <div class="how-it-works-actions-wrapper">
            <div style="text-align: center;" class="col-md-12">
                <button (click)="goBecomeAHost()" class="btn btn-orange">Become a Host</button>
            </div>
        </div>

        <div class="how-it-works-additional-wrapper">
            <p>
                Please check <a [routerLink]="['/', 'howitworks-for-shoppers']">How it works for shoppers? </a>page
                to have
                a better
                understanding of how shoppers use Shippn.
            </p>
        </div>
    </div>
</section>